export const CHROME_WEBSTORE_LINK =
  "https://chromewebstore.google.com/detail/webshare/bdokeillmfmaogjpficejjcjekcflkdh";

export const WEBSHARE_PROXY_DNS_ADDRESS =
  process.env.NODE_ENV === "development"
    ? "p.dev.webshare.io"
    : "p.webshare.io";

export const WEBSHARE_IP4_ADDRESS =
  process.env.NODE_ENV === "development"
    ? "ipv4.dev.webshare.io"
    : "ipv4.webshare.io";

export const INTERCOM_APP_ID =
  process.env.NODE_ENV === "development" ? "ruct6b4c" : "zsppwl0f";

/**
 * The regional Intercom host the published marketing pages name in their
 * snippet. It is the widget's own US default, so sending it changes nothing at
 * runtime, but the settings object is compared against live key by key and an
 * absent key reads as a difference.
 */
export const INTERCOM_API_BASE = "https://api-iam.intercom.io";

export const RESET_PASSWORD_TOKEN_COOKIE_KEY = "_resetpassword_token" as const;

export const ACTIVATION_TOKEN_COOKIE_KEY = "_activation_token" as const;

/**
 * Lifetime of both single-use token cookies. One definition because two places
 * write them: `src/server.ts` for a direct request (an emailed link), and the
 * confirm routes' `beforeLoad` for an in-app navigation.
 */
export const TOKEN_HANDOFF_MAX_AGE_SECONDS = 15 * 60;

/**
 * CookieYes builds a banner per account and serves it from a URL keyed by this
 * id, so the id is the whole configuration: there is nothing else to set.
 */
export const COOKIEYES_CLIENT_ID = "d0c5856455f2a3c292d3de21fbb16aa6";
